(function () {
  'use strict';

  var STORAGE_KEY = 'ev_consent_v1';
  var EXPIRY_DAYS = 365;

  /* ── Consent-Daten lesen/schreiben ── */

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data.ts) return null;
      var age = (Date.now() - data.ts) / 86400000;
      if (age > EXPIRY_DAYS) { localStorage.removeItem(STORAGE_KEY); return null; }
      return data;
    } catch (e) { return null; }
  }

  function writeConsent(analytics, marketing) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        necessary: true,
        analytics: !!analytics,
        marketing: !!marketing,
        ts: Date.now()
      }));
    } catch (e) {}
  }

  /* ── Shopify Customer Privacy API ── */

  function applyShopifyConsent(analytics, marketing) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!analytics,
          marketing: !!marketing,
          preferences: true,
          sale_of_data: false
        }, function () {});
      }
    } catch (e) {}
  }

  /* ── Banner-Elemente ── */

  var banner, modal;

  function showBanner() {
    if (banner) { banner.classList.add('is-visible'); }
  }

  function hideBanner() {
    if (banner) { banner.classList.remove('is-visible'); }
  }

  function openModal() {
    if (modal) {
      modal.classList.add('is-open');
      hideBanner();
      modal.querySelector('[data-consent-modal-focus]').focus();
    }
  }

  function closeModal(showBannerAfter) {
    if (modal) {
      modal.classList.remove('is-open');
      if (showBannerAfter) { showBanner(); }
    }
  }

  /* ── Zustimmung anwenden ── */

  function acceptAll() {
    writeConsent(true, true);
    applyShopifyConsent(true, true);
    hideBanner();
    closeModal(false);
  }

  function acceptNecessaryOnly() {
    writeConsent(false, false);
    applyShopifyConsent(false, false);
    hideBanner();
    closeModal(false);
  }

  function saveCustom() {
    var analyticsToggle = modal ? modal.querySelector('#ev-toggle-analytics') : null;
    var marketingToggle = modal ? modal.querySelector('#ev-toggle-marketing') : null;
    var analytics = analyticsToggle ? analyticsToggle.checked : false;
    var marketing = marketingToggle ? marketingToggle.checked : false;
    writeConsent(analytics, marketing);
    applyShopifyConsent(analytics, marketing);
    hideBanner();
    closeModal(false);
  }

  /* ── DOM aufbauen ── */

  function buildBanner() {
    var el = document.createElement('div');
    el.className = 'ev-consent';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-label', 'Cookie-Einstellungen');
    el.innerHTML = [
      '<div class="ev-consent__inner">',
        '<p class="ev-consent__text">',
          'Wir verwenden Cookies, um dir das beste Erlebnis auf unserer Website zu bieten. ',
          'Manche sind notwendig; andere helfen uns, die Website zu verbessern und relevante Inhalte zu zeigen. ',
          '<a href="/policies/privacy-policy">Datenschutzerklärung</a>',
        '</p>',
        '<div class="ev-consent__actions">',
          '<button class="ev-consent__btn ev-consent__btn--primary" data-consent-accept-all>Alle akzeptieren</button>',
          '<button class="ev-consent__btn ev-consent__btn--secondary" data-consent-necessary>Nur notwendige</button>',
          '<button class="ev-consent__btn ev-consent__btn--ghost" data-consent-settings>Einstellungen</button>',
        '</div>',
      '</div>'
    ].join('');
    return el;
  }

  function buildModal() {
    var el = document.createElement('div');
    el.className = 'ev-consent-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Cookie-Einstellungen');
    el.innerHTML = [
      '<div class="ev-consent-modal__box">',
        '<h2 class="ev-consent-modal__title" data-consent-modal-focus tabindex="-1">Cookie-Einstellungen</h2>',
        '<p class="ev-consent-modal__desc">',
          'Hier kannst du festlegen, welche Cookies wir verwenden dürfen. Notwendige Cookies sind immer aktiv, ',
          'da sie für den Betrieb der Website unerlässlich sind. Weitere Informationen findest du in unserer ',
          '<a href="/policies/privacy-policy">Datenschutzerklärung</a>.',
        '</p>',

        '<div class="ev-consent-category">',
          '<div class="ev-consent-category__info">',
            '<span class="ev-consent-category__label">Notwendig</span>',
            '<span class="ev-consent-category__desc">',
              'Diese Cookies sind für die Grundfunktionen der Website (Warenkorb, Session, Sicherheit) erforderlich.',
            '</span>',
          '</div>',
          '<label class="ev-consent-toggle" aria-label="Notwendige Cookies (immer aktiv)">',
            '<input type="checkbox" checked disabled>',
            '<span class="ev-consent-toggle__track"></span>',
          '</label>',
        '</div>',

        '<div class="ev-consent-category">',
          '<div class="ev-consent-category__info">',
            '<span class="ev-consent-category__label">Statistik</span>',
            '<span class="ev-consent-category__desc">',
              'Helfen uns zu verstehen, wie Besucher die Website nutzen (z.&nbsp;B. Google Analytics). ',
              'Alle Daten sind anonymisiert.',
            '</span>',
          '</div>',
          '<label class="ev-consent-toggle" aria-label="Statistik-Cookies">',
            '<input type="checkbox" id="ev-toggle-analytics">',
            '<span class="ev-consent-toggle__track"></span>',
          '</label>',
        '</div>',

        '<div class="ev-consent-category">',
          '<div class="ev-consent-category__info">',
            '<span class="ev-consent-category__label">Marketing</span>',
            '<span class="ev-consent-category__desc">',
              'Ermöglichen personalisierte Werbung auf externen Plattformen (z.&nbsp;B. Instagram, TikTok).',
            '</span>',
          '</div>',
          '<label class="ev-consent-toggle" aria-label="Marketing-Cookies">',
            '<input type="checkbox" id="ev-toggle-marketing">',
            '<span class="ev-consent-toggle__track"></span>',
          '</label>',
        '</div>',

        '<div class="ev-consent-modal__actions">',
          '<button class="ev-consent__btn ev-consent__btn--primary" data-consent-save-custom>Auswahl speichern</button>',
          '<button class="ev-consent__btn ev-consent__btn--secondary" data-consent-accept-all-modal>Alle akzeptieren</button>',
        '</div>',
      '</div>'
    ].join('');
    return el;
  }

  /* ── Toggle-Status aus gespeichertem Consent setzen ── */

  function applyStoredToToggles(consent) {
    if (!modal || !consent) return;
    var analyticsToggle = modal.querySelector('#ev-toggle-analytics');
    var marketingToggle = modal.querySelector('#ev-toggle-marketing');
    if (analyticsToggle) { analyticsToggle.checked = !!consent.analytics; }
    if (marketingToggle) { marketingToggle.checked = !!consent.marketing; }
  }

  /* ── Event Listeners ── */

  function bindEvents() {
    /* Banner */
    banner.addEventListener('click', function (e) {
      if (e.target.closest('[data-consent-accept-all]')) { acceptAll(); }
      if (e.target.closest('[data-consent-necessary]')) { acceptNecessaryOnly(); }
      if (e.target.closest('[data-consent-settings]')) { openModal(); }
    });

    /* Modal */
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-consent-save-custom]')) { saveCustom(); }
      if (e.target.closest('[data-consent-accept-all-modal]')) { acceptAll(); }
      /* Overlay-Klick schließt Modal (Banner wieder zeigen) */
      if (e.target === modal) { closeModal(true); }
    });

    /* ESC schließt Modal */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal(true);
      }
    });

    /* Footer-Link zum Öffnen der Einstellungen */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-consent-open-settings]');
      if (link) {
        e.preventDefault();
        var stored = readConsent();
        applyStoredToToggles(stored);
        openModal();
      }
    });
  }

  /* ── Init ── */

  function init() {
    var consent = readConsent();

    banner = buildBanner();
    modal = buildModal();
    document.body.appendChild(banner);
    document.body.appendChild(modal);

    bindEvents();

    /* Schon Consent? → Shopify API informieren, kein Banner */
    if (consent) {
      applyShopifyConsent(consent.analytics, consent.marketing);
      return;
    }

    /* Kein Consent → Banner nach kurzem Delay anzeigen */
    setTimeout(showBanner, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
